import { http } from "@/config/httpCommon"

export default {
    state: {
        colors: [],
        fonts: [],
        patterns: [],
        products: [],
        basic: '',
        fields: [],
        journey: [],
        sizes: [],
        logoTechnologies:[],
    },
    mutations: {
        set (state, [variable, value]) {
            state[variable] = value
        },
        add (state, [variable, value]) {
            state[variable].push(value);
        },
        ADD_PRODUCT(state, payload){
            state.products.push(payload);
        },
        ADD_SIZES(state, payload){
            state.sizes.push(payload);
        },
        SET_SIZES(state, payload){
            state.sizes = payload;
        },
        SET_LOGO_TECHNOLOGIES(state, payload){
            state.logoTechnologies = payload;
        },
        UPDATE_SIZES(state, payload){
            let index = state.sizes.filter(size => size.id == payload.id);
            state.sizes[index] = payload;
        },
        DELETE_SIZE(state, payload){
            state.sizes = state.sizes.filter(size => size.id != payload);
        }
    },
    getters:{
        getColors(state){
            return state.colors;
        },
        getFonts(state){
            return state.fonts;
        },
        getPatterns(state){
            return state.patterns;
        },
        getProducts(state) {
            return state.products;
        },
        getSizes(state) {
            return state.sizes;
        },
        getJourney(state) {
            return state.journey;
        },
        getLogoTechnologies(state){
            return state.logoTechnologies
        }
    },
    actions: {
        async getColors({commit}, params){
            let res = await http.get("files?file_type=color"+params);
            commit('set', ['colors', res.data.data]);
            return res;
        },
        async getFonts({commit}, params){
            let res = await http.get("files?file_type=font"+params);
            commit('set', ['fonts', res.data.data]);
            return res;
        },
        async getPatterns({commit}, params){
            let res = await http.get("files?file_type=product_pattern"+params);
            commit('set', ['patterns', res.data.data]);
            return res;
        },
        async addProduct({commit}, payload){
            let res = await http.post("product", payload);
            // commit('ADD_PRODUCT', res.data);
            return res;
        },
        async saveProductStep1({commit}, payload){
            let res = await http.post("product/save/step1", payload);
            return res;
        },
        async saveProductStep2({commit}, payload){
            let res = await http.post("product/save/step2", payload);
            return res;
        },
        async saveProductStep3({commit}, payload){
            let res = await http.post("product/save/step3", payload);
            // commit('ADD_PRODUCT', res.data);
            return res;
        },
        async saveProductStep4({commit}, payload){
            let res = await http.post("product/save/step4", payload);
            // commit('ADD_PRODUCT', res.data);
            return res;
        },
        async getProducts({commit}, payload=''){
            let res = await http.get("products"+payload);
            commit('set', ['products', res.data.data]);
            return res;
        },
        async getCompanies({commit}, params = ''){
            const url = `get-companies${params || ''}`;
            let res = await http.get(url);
            return res;
        },
        async getBasic({commit}, id){
            let res = await http.get(`admin/getbasic/${id}`);
            commit('set', ['basic', res.data.data]);
            return JSON.parse(JSON.stringify(res));
        },
        async getStyles({commit}, id){
            let res = await http.get(`admin/getstyles/${id}`);
            commit('set', ['fields', res.data.data]);
            return res;
        },
        async getJourney({commit}, id){
            let res = await http.get(`admin/getjourney/${id}`);
            commit('set', ['journey', res.data.data]);
            return JSON.parse(JSON.stringify(res));
        },
        async getCompanyFields({commit}, id){
            let res = await http.get(`get-product-company-fields/${id}`);
            commit('set', ['basic', res.data.data]);
            return JSON.parse(JSON.stringify(res));
        },
        async getDefaultProductFields({commit}, id){
            let res = await http.get(`get-default-product-fields/${id}`);
            commit('set', ['basic', res.data.data]);
            return JSON.parse(JSON.stringify(res));
        },
        async updateProduct({commit}, payload){
            let res = await http.put(`product/${payload.id}`, payload);
            commit('set', ['products', res.data.data]);
            return res;
        },
        async addDesign({commit}, payload){
            let res = await http.post("designfile", payload);
            return res;
        },
        async updateDesign({commit}, payload){
            let res = await http.post("update-designfile", payload);
            return res;
        },
        async getSizes({commit}, payload=null){
            let url = "sizes";
            if(payload) {
                url += payload;
            }
            let res = await http.get(url);
            commit('SET_SIZES', res.data.data);
            return res;
        },
        async getProductSizes({commit}, params){
            let res = await http.get("size-container?paginate=false"+params);
            commit('SET_SIZES', res.data.data);
            return res;
        },
        async addSizes({commit}, payload){
            let res = await http.post("sizes", payload);
            return res;
        },
        async updateSize({commit}, payload){
            let res = await http.put(`sizes/${payload.id}`, payload);
            commit('UPDATE_SIZES', res.data);
            return res;
        },
        async deleteSize({commit}, payload){
            let res = await http.delete(`sizes/${payload}`);
            commit('DELETE_SIZE', payload);
            return res;
        },
        async syncProduct({commit}, payload){
            let res = await http.post("product/sync", payload);
            // commit('ADD_PRODUCT', res.data);
            return JSON.parse(JSON.stringify(res));
        },
        async dissociateProduct({commit}, payload){
            let res = await http.post("product/dissociate", payload);
            // commit('ADD_PRODUCT', res.data);
            return JSON.parse(JSON.stringify(res));
        },
        async syncEcommercePrice({commit}, payload){
            let res = await http.post("product/sync-price", payload);
            // commit('ADD_PRODUCT', res.data);
            return JSON.parse(JSON.stringify(res));
        },
        async searchEcommerceProducts({commit}, payload){
            let res = await http.post("ecommerce/product/search", payload);
            // commit('ADD_PRODUCT', res.data);
            return JSON.parse(JSON.stringify(res));
        },
        async getLogoTechnologies({commit}, payload=null){

            let url = "logotechnologies";
            if(payload) {
                url += payload;
            }
            let res = await http.get(url);
            commit('SET_LOGO_TECHNOLOGIES', res.data.result.logoTechnologies);
            return res;
        },
    }
}